export const LOGIN_SOCIAL_BAR_NAMESPACE = 'login_social_bar';
export const OPTION_VALUE_TEXT = 'login_social_bar_choose_option_title';
export const CHOOSE_OPTION_TEXT_DEFAULT = 'Choose an option';

export const LOG_OUT_TEXT = 'login_social_bar_log_out_action';
export const LOG_OUT_TEXT_DEFAULT = 'Log Out';

export const LOGGED_OUT_TEXT = 'login_social_bar_log_in_action';
export const LOGGED_OUT_TEXT_DEFAULT = 'Log In';
